// Dependencies
import React, { FunctionComponent } from 'react'

// Styles
import {
  Container,
  DropdownContentContainer,
  DropdownListContainer,
  OpenedContent,
  StaticContentCompositionWrapper
} from './dropdown.styles'

export const Dropdown: FunctionComponent<any> = ({
  isOpened,
  staticContentComposition,
  openedContentComposition
}) => {
  return (
    <Container>
      <StaticContentCompositionWrapper>
        {staticContentComposition}
      </StaticContentCompositionWrapper>

      {isOpened && (
        <OpenedContent isOpened={isOpened}>
          {openedContentComposition}
        </OpenedContent>
      )}
    </Container>
  )
}

export const DropdownContent: FunctionComponent = ({ children }) => {
  return (
    <DropdownContentContainer className="sisu-dropdown-content">
      <div className="container">{children}</div>
    </DropdownContentContainer>
  )
}

export const DropdownList: FunctionComponent<any> = ({ content }) => {
  return (
    <DropdownListContainer>
      <ul className="list">
        {content.map((item: any) => (
          <li className="list-item" onClick={() => item.handleClick()}>
            {item.image && <img alt={item.label} src={item.image} />}
            {item.label}
          </li>
        ))}
      </ul>
    </DropdownListContainer>
  )
}
